import { publishTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const publishTenderCallable = getCallable(publishTenderDefinition);
